import { Icon } from "office-ui-fabric-react";

export const PrivacyPolicy = () => {
    return (
        <div id="introModal">
            <p><a href={window.location.protocol + '//' + window.location.host}>Back to site</a></p>
            <div id="introContainer" style={{margin: "20px auto", width: "calc(100% - 50px)", maxWidth: 900}}>
                <div style={{display: "flex", justifyContent: "flex-end"}}>
                    {/* <img src="/api/logo" alt="Trust Logo" /> */}
                    <img src="/NHS_Informatics_Merseyside.png" alt="Informatics Merseyside Logo" />
                </div>
                <h2 style={{textAlign: "center"}}>Desk Booking Privacy Policy</h2>
                <p>
                    <strong>NHS Informatics Merseyside</strong> are responsible for the 
                    management of this website and take the privacy of information provided 
                    by visitors to this website extremely seriously.
                </p>
                <p>
                    This policy pertains strictly to the Mersey Care Desk Booking website:
                </p>
                <ul>
                    {/* <li style={{marginBottom: 20}}>
                        For the Innovation Agency Privacy Policy please click here:<br/>
                        <a href="https://www.innovationagencynwc.nhs.uk/privacy-policy" target="_blank" rel="noreferrer">
                        https://www.innovationagencynwc.nhs.uk/privacy-policy
                        </a>
                    </li> */}
                    <li style={{marginBottom: 20}}>
                        For the Mersey Care Privacy Policy please click here:<br/>
                        <a href="https://www.merseycare.nhs.uk/about-us/privacy/privacy-statement" target="_blank" rel="noreferrer">
                        https://www.merseycare.nhs.uk/about-us/privacy/privacy-statement
                        </a>
                    </li>
                    <li>
                        This website integrates with the Microsoft Azure platform, allowing users with
                        Microsoft Accounts to authenticate to the site and use its features. 
                        Microsoft collect information about you and your organisation in order to provide this
                        service. Please click here to read Microsoft's Privacy Statement:<br/>
                        <a href="https://privacy.microsoft.com/en-gb/privacystatement" target="_blank"
                        rel="noreferrer">https://privacy.microsoft.com/en-gb/privacystatement</a>
                    </li>
                </ul>
                <p>
                    We do not capture or store personal information about individuals who 
                    use this desk booking service, except where this information is given voluntarily.
                </p>
                <h3>What information do we collect?</h3>
                <p>
                    This application uses your Microsoft Account as your application identity. 
                    On agreeing to use this service, you will be prompted for consent to share information 
                    with us from your Microsoft Account. This grants us access to the following:
                </p>
                <ul>
                    <li>your Display Name,</li>
                    <li>your First and Last name,</li>
                    <li>your Email Address,</li>
                    <li>your Profile Photo,</li>
                    <li>and the name of the Organisation associated with your Microsoft account; 
                        for example, merseycare.nhs.uk, sthelensccg.nhs.uk, sthelens.gov.uk</li>
                </ul>
                <h3>How do we use the information we collect?</h3>
                <p>
                    Information about your account is persisted to the application database - so that:  
                </p>
                <ul>
                    <li>bookings can be assigned to you,</li>
                    <li>other users can have visibility of those bookings,</li>
                    <li>you can be contacted via email (ie. for booking confirmation or cancellation purposes),</li>
                    <li>Innovation Agency can audit usage of their desks and resources</li>
                </ul>
                <p>
                    In order to improve the website and access to information and services, Informatics 
                    Merseyside may additionally collect and store the following information each time 
                    you visit our site: the date and time, the originating IP, the type of browser and 
                    operating system used, the URL of the referring page, the object requested, and the 
                    completion status of the request. This information may be collected for web requests 
                    that are made by both anonymous and authenticated users.
                </p>
                <p>
                    Informatics Merseyside will endeavour to safeguard your information and will not pass 
                    it on to any third party without the express permission of the individual or unless 
                    required to do so by lawful authority.
                </p>
                <p>
                    Information we collect is retained only as long as it is needed. Data for historical 
                    bookings will be deleted on an ongoing basis. If you sign-in with your Microsoft Account 
                    and would later like us to remove you from this system, please <a href="#contactus">contact 
                    us</a> and we will ensure your profile is fully deleted.
                </p>
                <h3>Cookies</h3>
                <p>
                    When we provide services, we want to make them easy, useful and reliable. Where services 
                    are delivered on the internet, this sometimes involves placing small amounts of 
                    information on your device, for example, computer or mobile phone. These include small 
                    files known as cookies. They cannot be used to identify you personally.
                </p>
                <p>These pieces of information are used to improve services for you through, for example:</p>
                <ul>
                    <li>
                        Enabling a service to recognise your device so you don't have to give the same 
                        information several times during one task.
                    </li>
                    <li>
                        Recognising that you may already have given a username and password so you don't 
                        need to do it for every web page requested.
                    </li>
                </ul>
                <p>
                    You can manage these small files yourself and learn more about them through <a href="https://www.gov.uk/help/cookies" target="_blank" rel="noreferrer">Internet 
                    browser cookies - what they are and how to manage them.</a>
                </p>
                <p>The following cookie is stored on your device when you authenticate with your Microsoft Account:</p>
                <blockquote>
                    <strong>Name:</strong> .AspNetCore.Cookies <br/>
                    <strong>Typical Content:</strong> Randomly generated hash / string, unique to the authenticated user.<br/>
                    <strong>Expires:</strong> On browser close (session cookie)
                </blockquote>
                <h3>Local Browser Storage</h3>
                <p>
                    Administrators who use this site can configure floorplan layouts for desk bookings. 
                    Local browser storage is used to provide an auto-save feature that is resilient to network outage. 
                    Saves occur with each meaningful change to the diagram, even if a network is unavailable. This 
                    helps to prevent administrators losing work. When a network becomes available again, this work can be 
                    saved to the server. This data contains no user identifiable information and is automatically cleared 
                    from browser data whenever a diagram is published. Users can manually clear local storage for the 
                    site via browser settings or developer tools.  
                </p>
                <h3>Notification of changes</h3>
                <p>
                    Informatics Merseyside may revise this Privacy Policy at any time. You will not receive notification 
                    of these changes but they will be published on this page.
                </p>
                <h3><a id="contactus" href="#contactus"><Icon iconName="Link" /></a> Contact Us</h3>
                <p>
                    The Trust’s Data Protection Officer (DPO) is the Head of Information Governance, 
                    who is supported in this role by the IG Team. The DPO can be contacted by emailing <a 
                    href="mailto:DPO@merseycare.nhs.uk">DPO@merseycare.nhs.uk</a> or <a 
                    href="mailto:IG@merseycare.nhs.uk">IG@merseycare.nhs.uk</a>.
                </p>
                <p>
                    To request information about this website or anything in this policy, email:<br/>
                    <a href="mailto:development.service@imerseyside.nhs.uk?Subject=Desk Booking System">development.service@imerseyside.nhs.uk</a> 
                </p>
                <h3>Right to Complain</h3>
                <p>
                    NHS Informatics Merseyside aims to make sure that the services it delivers are 
                    provided to the highest standard.  If you have any concerns about the way the 
                    Trust has handled its data, you can raise your concerns or make a complaint.
                </p>
                <ul>
                    <li>
                        To raise a concern, please contact the IG Team by emailing <a 
                        href="mailto:IG@merseycare.nhs.uk">IG@merseycare.nhs.uk</a> or <a 
                        href="mailto:DPO@merseycare.nhs.uk">DPO@merseycare.nhs.uk</a>.
                    </li>
                    <li>
                        To make an external complaint about the Trust’s data handling, please contact 
                        the ICO by emailing <a href="mailto:casework@ico.org.uk">casework@ico.org.uk</a> or 
                        phone 0303 123 1113.
                    </li>
                </ul>
            </div>
        </div>
    );
}